import { render, staticRenderFns } from "./Defaul.vue?vue&type=template&id=76bc3bca&scoped=true"
import script from "./Defaul.vue?vue&type=script&lang=js"
export * from "./Defaul.vue?vue&type=script&lang=js"
import style0 from "./Defaul.vue?vue&type=style&index=0&id=76bc3bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bc3bca",
  null
  
)

export default component.exports